/**
 * Client-side validation that mirrors the backend (class-validator) so users get
 * immediate feedback. The server remains authoritative. Auth is Google-only, so
 * the only field rule is a valid email (no passwords).
 */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_RE.test(email.trim());
}

/** Pull a human message out of an RTK Query / Nest error envelope. */
export function apiErrorMessage(err: unknown, fallback = 'Something went wrong'): string {
  const data = (err as { data?: unknown } | undefined)?.data;
  if (data && typeof data === 'object' && 'message' in data) {
    const message = (data as { message?: unknown }).message;
    if (Array.isArray(message)) return message.join(', ');
    if (typeof message === 'string') return message;
  }
  if ((err as { status?: unknown })?.status === 'FETCH_ERROR') return 'Network error — is the server running?';
  return fallback;
}
